<template>
    <div>
        <div class="object-titlebox">
            <div v-if="selectedNode.data.type == 0">
                <div class="object-titlebox-left" v-t="'message.title_user_rights1'"></div>
            </div>
            <div v-else>
                <div class="object-titlebox-left" v-t="{ path: 'message.title_user_rights2', args: { rights: selectedNode.data.label } }">
                </div>
            </div>
            <div v-if="selectedNode.data.type != 0" class="object-titlebox-right">
                <div v-if="rightsUserList.length == 0">
                    <button class="transparent" type="button" v-on:click="showEditUserPrivilegesDialog()"><img src="../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.action_add_rights_to_user'"></span></button>
                </div>
                <div v-else>
                    <button class="transparent" type="button" v-on:click="showEditUserPrivilegesDialog()"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.action_edit_rights_of_user'"></span></button>
                </div>
            </div>
            <div v-if="selectedNode.data.type != 0"　style="padding-left: 20px;color: #848991;font-size: 12px;">{{ getDescriptionOfRights() }}</div>
        </div>
        <div v-if="selectedNode.data.type == 0">
            <div class="object-inner-table">
                <table width=100%>
                    <tr width="100%" class="no-data-message">
                        <td style="display: inline-block" v-t="'message.info_select_rights_of_user'">
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div v-else>
            <div class="object-titlebox">
                <div class="object-titlebox-left">
                    <el-form @submit.native.prevent="submit">
                        <el-input :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchKeyword" class="input-with-select" clearable  @clear="getInfo(0)" :disabled="userSearchDisabled" >
                            <el-select v-model="condition" slot="prepend" :placeholder="$t('message.place_holder_search_condition')">
                                <el-option :label="$t('message.item_userId')" value="name"></el-option>
                                <el-option :label="$t('message.item_userDisplayName')" value="displayName"></el-option>
                                <el-option :label="$t('message.item_organization')" value="organization"></el-option>
                                <el-option :label="$t('message.item_job_title')" value="title"></el-option>
                            </el-select>
                            <el-button slot="append" @click="getInfo(1)" style="width: 100px; vertical-align: middle;" native-type="submit"  v-t="'message.action_filter_items'"></el-button>
                        </el-input>
                    </el-form>
                </div>
            </div>
            <div class="object-inner-table">
                <table width=100%>
                    <tr class="item-list-title">
                        <td width=50% class="object-item">
                            <div class="object-userlist-left">
                                <div class="object-userlist-right">
                                    <span class="item-list-header" v-t="'message.common_action_delete'"></span>
                                </div>
                                <span class="item-list-header" v-t="'message.item_userId_displayName'"></span>
                            </div>
                        </td>
                    </tr>
                    <tr width="100%" v-if="rightsUserList.length == 0" class="no-data-message">
                        <div v-if="searchKeyword == null">
                            <td style="display: inline-block" v-t="{ path: 'message.info_user_not_found_with_rights', args: { rights: selectedNode.data.label } }"></td>
                        </div>
                        <div v-else>
                            <td style="display: inline-block" v-t="'message.info_user_not_found'"></td>
                        </div>
                    </tr>
                    <tr v-for="(rightsUser,index) in rightsUserList" class="record-with-underline">
                        <td width=50% class="object-item">
                            <div class="object-userlist-left">
                                <div class="object-userlist-right">
                                    <button class="item-record-button" type="button" v-on:click="removeRightsConfirm(index)"><img class="icon-delete" src="../assets/icon_delete_user.svg" /></button>
                                </div>
                                {{ getUserDisplayName(rightsUser) }}
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <edituserprivileges v-if="showEditUserPrivileges" :appData="appData" :privilege="selectedNode.data.privilegeName" :editUserList="getRightsUserList(selectedNode.data.privilegeName)" @save="saveUserRights" @cancel="showEditUserPrivileges=false"></edituserprivileges>
        <confirmdeleteuser v-if="showConfirmDeleteUser" :confirmInfo="confirmInfo" @delete="removeRights" @cancel="showConfirmDeleteUser=false"></confirmdeleteuser>
    </div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import EditUserPrivileges from "./EditUserPrivileges.vue";
import DeleteObject from "./DeleteObject.vue";
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data() {
      return {
            condition: "name",
            searchKeyword: null,
            showEditUserPrivileges: false,
            showConfirmDeleteUser: false,
            userSearchDisabled: true,
            tenantManageRights: false,
            removeRightsIndex: 0,
            rightsUserList: [],
            rightsTenantAdmin: [],
            rightsAlert: [],
            confirmInfo: {
                objectName: null,
                objectTitle: null
            },
      };
    },
    methods: {
        getInfo(getType) {
            let self = this;

            let param = { tenantId: this.appData.tenantList[0].tenantId, rights: 1}
            if (getType == 0) {
                this.searchKeyword = null;
            } else {
                if (this.condition == "name") {
                    param.name = this.searchKeyword;
                } else if (this.condition == "displayName") {
                    param.displayName = this.searchKeyword;
                } else if (this.condition == "organization") {
                    param.organization = this.searchKeyword;
                } else if (this.condition == "title") {
                    param.title = this.searchKeyword;
                } else {
                    commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_search_condition_not_found"));
                    return;
                }
            }

            server.post('/finduser', param)
            .then((res) => {
                self.rightsTenantAdmin = [];
                self.rightsAlert = [];
                switch(res.data.status) {
                    case 0:
                        for (let user of res.data.userInfo) {
                            if (commonUtil.checkUserPrivilege(user.rights, constants.PRIVILEGE_TENANT_ADMIN)) {
                                self.rightsTenantAdmin.push(user);
                            }
                            if (commonUtil.checkUserPrivilege(user.rights, constants.PRIVILEGE_ALERT)) {
                                self.rightsAlert.push(user);
                            }
                        }
                        break;
                    case -3:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getInfo").replace("{code}",res.data.status));
                        break;
                }
                self.refreshRightsUserList();
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getInfo", error);
            });
        },
        getUserRights() {
            let self = this;
            let loginId =  this.appData.loginId.split("@");
            server.post('/getinfo',{tenantId: this.appData.tenantList[0].tenantId, name: loginId[0], type: 1, userTalkgroupInfo: false }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.tenantManageRights = commonUtil.checkUserPrivilege(res.data.rights, constants.PRIVILEGE_TENANT_ADMIN);
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_confirm_rights_by_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getUserRights").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getUserRights", error);
            });
        },
        showEditUserPrivilegesDialog() {
            if (this.selectedNode.data.privilegeName == constants.PRIVILEGE_TENANT_ADMIN) {
                if (!this.tenantManageRights) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_grant_rights_by_denied"));
                    return;
                }
            }
            this.showEditUserPrivileges = true;
        },
        saveUserRights(input) {
            this.showEditUserPrivileges=false;

            let targetRightsUserList;
            let privilegeName = this.selectedNode.data.privilegeName;
            let rightsDisplayName;
            switch(this.selectedNode.data.privilegeName) {
                case constants.PRIVILEGE_TENANT_ADMIN:
                    targetRightsUserList = this.rightsTenantAdmin;
                    rightsDisplayName = commonUtil.getMessageText(this.$i18n,"item_tenant_management");
                    break;
                case constants.PRIVILEGE_ALERT:
                    targetRightsUserList = this.rightsAlert;
                    rightsDisplayName = commonUtil.getMessageText(this.$i18n,"item_send_alert");
                    break;
            }

            let modifiedRightsUserList = [];
            for (let userInfo of targetRightsUserList) {
                modifiedRightsUserList.push(userInfo);
            }

            let operations = [];
            for (let key in input.addTagList) {
                let tag = input.addTagList[key]
                if (tag.orgRights == null) {
                    tag.orgRights = "";
                }
                if (tag.orgRights.indexOf(privilegeName) == -1) {
                    let newRights;
                    if (tag.orgRights != "") {
                        newRights = tag.orgRights + "," + privilegeName;
                    } else {
                        newRights = privilegeName;
                    }
                    operations.push({
                        command: "modifyuser",
                        operation: {
                            tenantId: tag.tenantId,
                            name: tag.userName,
                            newRights: newRights
                        }
                    })
                    modifiedRightsUserList.push({
                       id: tag.userName,
                       name: tag.userName,
                       displayName: tag.displayName,
                       rights: newRights
                   })
                }
            }

            for (let key in input.removeTagList) {
                let tag = input.removeTagList[key]
                if (tag.orgRights == null) {
                    continue;
                }
                if (tag.orgRights.indexOf(privilegeName) >=0) {
                    let privilegeList = tag.orgRights.split(",");
                    let newRights = "";
                    for (let privilege of privilegeList) {
                    	if (privilege != privilegeName) {
                    		if (newRights != "") {
                    			newRights += ",";
                    		}
                    		newRights += privilege ;
                    	}
                    }
                    operations.push({
                        command: "modifyuser",
                        operation: {
                            tenantId: tag.tenantId,
                            name: tag.userName,
                            newRights: newRights,
                        }
                    })
                    for (let i=0 ; i < modifiedRightsUserList.length ; i++) {
                        if (modifiedRightsUserList[i].name == tag.userName) {
                            modifiedRightsUserList.splice(i,1);
                        }
                    }
                }
            }

            if (operations.length == 0) {
                return;
            }

            const loading = this.$loading({
                    lock: true ,
                    text: 'Updating console user rights.' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });
            let timer = setTimeout(() => {
                      loading.close();
                      commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"info_need_time_until_finish"));
                    }, 5000);
            let self = this;
            server.post('/multiop', {operations: operations})
                .then((res) => {
                    clearTimeout(timer);
                    loading.close();
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_user_rights").replace("{rights}",rightsDisplayName));
                            this.refreshRightsUserList();
                            this.getInfo(0);
                            break;
                        case constants.STATUS_ERROR_BATCH_PROCESS:
                            const isDeletedTenant = res.data.errorInfo.findIndex(data => data.errorCode === constants.STATUS_ERROR_TENANT_ALREADY_DELETED);
                            if (isDeletedTenant !== -1) {
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted_unknown_details"));
                                break;
                            }
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_rights_by_denied"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","saveUserRights").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "saveUserRights", error);
                });
        },
        removeRightsConfirm(index) {
            this.removeRightsIndex = index
            switch(this.selectedNode.data.privilegeName) {
                case constants.PRIVILEGE_TENANT_ADMIN:
                    if (this.rightsUserList.length == 1) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_revoke_rights_by_no_users"));
                        return;
                    }
                    if (!this.tenantManageRights) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_revoke_rights_by_denied"));
                        return;
                    }
                    if (this.isImportWantUser(this.rightsUserList[index])) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_revoke_rights_by_linkAdmin"));
                        return;
                    }
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_user_rights2").replace("{rights}",commonUtil.getMessageText(this.$i18n,"item_tenant_management"));
                    break;
                case constants.PRIVILEGE_ALERT:
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_user_rights2").replace("{rights}",commonUtil.getMessageText(this.$i18n,"item_send_alert"));
                    break;
            }
            this.confirmInfo.objectName = this.rightsUserList[this.removeRightsIndex].displayName;
            this.showConfirmDeleteUser = true;
        },
        removeRights() {
            this.showConfirmDeleteUser = false;
            let self = this;
            let newRights = "";
            if (this.rightsUserList[this.removeRightsIndex].rights.indexOf(this.selectedNode.data.privilegeName) >=0) {
                let rightsList = this.rightsUserList[this.removeRightsIndex].rights.split(",");
                for (let rights of rightsList) {
                    if (rights != this.selectedNode.data.privilegeName) {
                        if (newRights != "") {
                            newRights += ",";
                        }
                        newRights += rights ;
                    }
                }
            } else {
                return;
            }

            let targetUserName = this.rightsUserList[this.removeRightsIndex].name;
            server.post('/modifyuser', {
                    operation: {
                        tenantId: this.appData.tenantList[0].tenantId,
                        name: targetUserName,
                        newRights: newRights
                    }
                })
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            let rightsDisplayName;
                            switch(this.selectedNode.data.privilegeName) {
                                case constants.PRIVILEGE_TENANT_ADMIN:
                                    rightsDisplayName = commonUtil.getMessageText(this.$i18n,"item_tenant_management");
                                    break;
                                case constants.PRIVILEGE_ALERT:
                                    rightsDisplayName = commonUtil.getMessageText(this.$i18n,"item_send_alert");
                                    break;
                            }
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_delete_user_rights").replace("{rights}",rightsDisplayName).replace("{userName}",targetUserName));
                            self.getInfo(0);
                            break;
                        case constants.STATUS_ERROR_PERMISSION_DENIED:
                            commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_remove_tenantadmin_prev_from_consoleadmin"));
                            break;
                        case constants.STATUS_ERROR_BATCH_PROCESS:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_rights_by_denied"));
                            break;
                        case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted_unknown_details"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","removeRights").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "removeRights", error);
                });
        },
        getRightsUserList(privilege) {
            switch(privilege) {
                case constants.PRIVILEGE_TENANT_ADMIN:
                case constants.PRIVILEGE_ALERT:
                    return this.rightsUserList;
            }
        },
        getUserDisplayName(userInfo) {
            return userInfo.name + "@" +  this.appData.tenantList[0].name + " / " + userInfo.displayName;
        },
        refreshRightsUserList() {
            switch(this.selectedNode.data.privilegeName) {
                case constants.PRIVILEGE_TENANT_ADMIN:
                    this.rightsUserList = this.rightsTenantAdmin;
                    break;
                case constants.PRIVILEGE_ALERT:
                    this.rightsUserList = this.rightsAlert;
                    break;
            }
            if (this.searchKeyword == null) {
                if (this.rightsUserList.length == 0) {
                    this.userSearchDisabled = true;
                } else {
                    this.userSearchDisabled = false;
                }
            }
        },
        getDescriptionOfRights() {
            switch(this.selectedNode.data.privilegeName) {
                case constants.PRIVILEGE_TENANT_ADMIN:
                    if ((this.appData.onlinePurchase) || (this.appData.webTrialTenant)) {
                        return commonUtil.getMessageText(this.$i18n,"info_desc_tenantAdmin_rights1");
                    } else {
                        return commonUtil.getMessageText(this.$i18n,"info_desc_tenantAdmin_rights2");
                    }
                case constants.PRIVILEGE_ALERT:
                    return commonUtil.getMessageText(this.$i18n,"info_desc_alert_rights");
            }
        },
        isImportWantUser(userInfo) {
            for (let tenant of this.appData.importedTenantList) {
                if (tenant.wantUserId == userInfo.id) {
                    return true;
                }
            }
            return false;
        }
    },
    components: {
        edituserprivileges: EditUserPrivileges,
        confirmdeleteuser: DeleteObject,
    },
    created: function() {
        if (this.appData.tenantList.length > 0) {
            this.getInfo(0);
            this.getUserRights()
        }
    },
    mounted: function() {
    },
    watch: {
        'appData.tenantList'(newVal) {
            this.getInfo(0);
            this.getUserRights()
        },
        'selectedNode'(newVal) {
            this.getInfo(0);
        }
    },
    props: [ 'appData' , 'selectedNode' , 'clientConfigOption' ]
}

</script scoped>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.record-with-underline {
    border-bottom:1px #eee solid;
}

.input-with-select {
    width: 400px;
}
.input-with-select >>> .el-input-group__prepend {
    background-color: #fff;
}
.input-with-select >>> .el-select .el-input {
    font-size: 14px;
    width: 120px;
}
.input-with-select >>> .el-button {
    width: 40px;
    padding: 0;
}
.input-with-select >>> .el-input__inner {
    font-size: 14px;
    padding-left: 10px;
}
.el-select >>> .el-input__inner {
    font-size: 14px;
    padding-left: 10px;
}
.el-select-dropdown__item {
    font-size: 14px;
}

</style>
